import ReactGA from 'react-ga';
export default function(eventTracker) {
    return store => next => action => {
        ReactGA.event({
            category: "Action",
            action: action.type,
            value: parseFloat(action.meta),
            nonInteraction: true
        });

        return next(action);
    };
}


// WEBPACK FOOTER //
// ./src/utilities/google-analytics-middleware.js